"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.taskStatesDifferent = void 0;
/**
 * Compare the task states "a" and "b" for differences.
 * @param {Partial<Record<Tasks, ITaskState>>} a - The first task state
 * @param {Partial<Record<Tasks, ITaskState>>} b - The second task state
 *
 * @returns {boolean} diff - True if the task states are different
 */
const taskStatesDifferent = (a, b) => {
    if (a === undefined && b === undefined) {
        return false;
    }
    else if (a === undefined || b === undefined) {
        return true;
    }
    else {
        return Array.from(new Set([...Object.keys(a), ...Object.keys(b)]))
            .findIndex((task) => { var _a, _b; return ((_a = a[task]) === null || _a === void 0 ? void 0 : _a.completion) !== ((_b = b[task]) === null || _b === void 0 ? void 0 : _b.completion); }) >= 0;
    }
};
exports.taskStatesDifferent = taskStatesDifferent;
//# sourceMappingURL=taskDiff.js.map